import { render } from "./Home.vue?vue&type=template&id=4081b8f7"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=4081b8f7&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__